import { Box, TextFieldProps, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import type { FactoryOpts } from "imask";
import React, { forwardRef, memo } from "react";

import { mergeRefs, useMask } from "../../hooks";

export type MaskOptions = {
  mask: FactoryOpts;
};

type IMaskTextFieldProps = TextFieldProps & {
  mask: MaskOptions;
  onAccept?: () => void;
  onComplete?: () => void;
}

const styles: Record<string, SxProps<Theme>> = {
  wrapper: {
    width: "100%",

    "& .MuiTypography-root": {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#25282D",
      marginBottom: "4px",
    },

    "& .MuiFormHelperText-root": {
      marginLeft: 0
    },

    "& .MuiInputBase-multiline": {
      paddingTop: 0,
      paddingLeft: 0,
    },

    "& fieldset": {
      borderColor: "#E0E4EE",
    }
  },
  label: {
    "& span": {
      color: "#FF0000"
    }
  }
};
const MuiFormMaskedInput = forwardRef<
  HTMLInputElement,
  IMaskTextFieldProps
>(({
  mask,
  onAccept,
  onComplete,
  variant,
  label,
  required,
  ...otherProps
}, forwardedRef) => {


  const { inputRef } = useMask({
    onAccept,
    onComplete,
    maskOptions: mask.mask,
  });

  const ref = mergeRefs(forwardedRef, inputRef);

  return (
    <Box sx={styles.wrapper}>
      {label && (
        <Typography sx={styles.label}>
          {label}
          {required && <span>*</span>}
        </Typography>
      )}
      <TextField
        variant={variant || "outlined"}
        {...otherProps}
        inputRef={ref}
      />
    </Box>
  );
});

export default memo(MuiFormMaskedInput);
